import { OsUpdate } from '@era/osupdates-sdk';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AvailableOsUpdatesResolverActions = createActionGroup({
  source: 'Available Os Updates Resolver',
  events: {
    'Available os updates requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const OsUpdatesApiActions = createActionGroup({
  source: 'OsUpdates API',
  events: {
    'Available os updates loaded': props<{ availableOsUpdates: OsUpdate[] }>(),
    'Available os updates loaded error': props<{ error: ErrorModel }>(),
  },
});
